import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { AlternativePrice } from 'src/types';
import { getCampaignByOfferId } from '../../../utils';
import { OfferPriceLabel } from 'src/components/offer/price/offer-price-experiment';

import { Column, Row } from './styles';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';

type PriceInfoProps = {
  alternativeOffer?: AlternativePrice;
};

export const PriceInfoExperiment = (props: PriceInfoProps) => {
  const { alternativeOffer } = props;

  const { campaign, offer } = usePriceRowContext();
  const { getPriceDisplay } = useOfferListFilterContext();

  // Get props from alternative offer if supplied
  const id = alternativeOffer ? alternativeOffer.id : offer.priceId;
  const price = alternativeOffer ? alternativeOffer.price : offer.price;
  const offerPrices = alternativeOffer
    ? alternativeOffer.offerPrices
    : offer.offerPrices;

  const activeCampaign = getCampaignByOfferId(id, campaign);

  return (
    <Column>
      <Row>
        {price && (
          <OfferPriceLabel
            price={price}
            offerPrice={offerPrices}
            priceDisplay={getPriceDisplay()}
            campaignColors={activeCampaign?.media?.colors}
          />
        )}
      </Row>
    </Column>
  );
};
